module.exports = __webpack_public_path__ + "img/rewardBg.7d9f2547.png";